import { CustomFilterType, CustomPivotTabIdSeparator, } from '@office-start/base-edgeworth-control';
export function getFilteredCustomPivotKey(filterType, filterKey) {
    var filteredCustomPivotKey = '';
    switch (filterType) {
        case CustomFilterType.OwnedBy:
        case CustomFilterType.SharedBy:
        case CustomFilterType.Tag:
        case CustomFilterType.Tagv2:
            filteredCustomPivotKey = filterType;
            break;
        case CustomFilterType.FileType:
        case CustomFilterType.Location:
            filteredCustomPivotKey = "".concat(filterType).concat(CustomPivotTabIdSeparator).concat(filterKey);
            break;
    }
    return filteredCustomPivotKey;
}
//# sourceMappingURL=getFilteredCustomPivotKey.js.map